module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recipients":"Recipients","hla_information":"HLA Information"},"fr":{"recipients":"Patients","hla_information":"Information HLA"}}')
  delete Component.options._Ctor
}
